var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnersEditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1.33398H25M22.4667 1.33398V14.3713C22.4667 14.9993 22.2133 15.602 21.764 16.0473C21.3133 16.4913 20.7027 16.7407 20.0667 16.7407H5.93333C5.29733 16.7407 4.68667 16.4913 4.236 16.0473C4.01392 15.8283 3.83748 15.5673 3.71687 15.2797C3.59626 14.992 3.53388 14.6833 3.53333 14.3713V1.33398M7 22.6673L13 16.742L19 22.6673",
    stroke: "#139CFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnersEditor);
export default __webpack_public_path__ + "static/media/partners-editor.f67d7740253edcd0cda784ca2a06cc70.svg";
export { ForwardRef as ReactComponent };